
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9f35"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9f35"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4SSe9", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $38e644f71e40bb30$export$6503ec6e8aabbaf; }, function (v) { return $38e644f71e40bb30$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $38e644f71e40bb30$export$f7ad0328861e2f03; }, function (v) { return $38e644f71e40bb30$export$f7ad0328861e2f03 = v; });
var $38e644f71e40bb30$export$6503ec6e8aabbaf;
var $38e644f71e40bb30$export$f7ad0328861e2f03;
"use strict";
var $38e644f71e40bb30$var$mapping = new Map();
function $38e644f71e40bb30$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$38e644f71e40bb30$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $38e644f71e40bb30$var$resolve(id) {
    var resolved = $38e644f71e40bb30$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$38e644f71e40bb30$export$6503ec6e8aabbaf = $38e644f71e40bb30$var$register;
$38e644f71e40bb30$export$f7ad0328861e2f03 = $38e644f71e40bb30$var$resolve;

});

var $cad0b9d6c626c89c$exports = {};

(parcelRequire("4SSe9")).register(new URL("", import.meta.url).toString(), JSON.parse('["7DVdJ","authorize.8e7a4b81.js","kPsoI","web-vitals.5960fe53.js"]'));


//# sourceMappingURL=authorize.runtime.991cec06.js.map
